import { FC, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import AttivaCard from "../../../../components/card/AttivaCard";
import { Loader } from "../../../../components/loader/SpinnerLogo";
import useFetch from "../../../../hooks/useFetch";
import useHandleErrors from "../../../../hooks/useHandleErrors";
import PageHeader from "../../../../layout/shared/page-header";
import { menuRoutes } from "../../../../router/menu";
import { KoReasonService } from "../../../../services/ko-reason/koReasonService";
import KoReasonForm from "../KoReasonForm";


const KoReasonEdit: FC = () => {

    const { id = "" } = useParams<{ id: string }>();
    const { handleErrors } = useHandleErrors();
    const navigate = useNavigate();
    const service = new KoReasonService();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [data, loading] = useFetch(useCallback(async () => {
        const response = await service.getKoReasonById(id as string);
        return response.getResponseData();
    }, [id]));

    const pageHeader = {
        title: `Editar Motivo de KO ( ${data?.name} )`,
        breadcrumb: [
            { name: 'Administración' },
            { name: 'Gestión de estados' },
            { name: 'Motivos de KO', href: menuRoutes.states.path + menuRoutes.states.koReasons },
            { name: 'Editar' },
        ],
    };

    const handleSubmit = async (values: any) => {
        setIsLoading(true);
        try {
            const response = (await service.editKoReason(values)).getResponseData();
            if (response.success) {
                navigate(-1);
                toast.success("Motivo de KO editado correctamente");
            } else {
                handleErrors(response);
            }
        } catch (error: any) {
            toast.error("Error al editar el motivo de KO");
        } finally {
            setIsLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <AttivaCard title="Datos Principales">
                {(data !== null && data !== undefined) && <KoReasonForm data={data} submit={handleSubmit} isLoading={isLoading} />}
            </AttivaCard>
        </>
    );
}

export default KoReasonEdit;
